/* eslint no-bitwise: [2, { allow: ["~"] }] */

import React, { FC } from "react";

import { FileWithPath } from "react-dropzone";

import { CrossLight, PdfIcon } from "@/assets/icons";

import { StyledFileUploaderBox } from "./styled";

type FileProps = {
    file: FileWithPath;
    onExcludeFile: () => void;
};

const File: FC<FileProps> = ({ file, onExcludeFile }) => {
    const preview = file.type.includes("image/") ? URL.createObjectURL(file) : null;
    return (
        <StyledFileUploaderBox $withoutPreview={!preview}>
            {preview && (
                <div className="image-container">
                    <img src={preview} data-testid="preview-file" alt="" className="fileUploaderFileImage" />
                </div>
            )}
            <CrossLight data-testid="remove-file" className="file-uploader-close" onClick={onExcludeFile} />
            {!preview && (
                <div className="file-uploader-file">
                    <PdfIcon />
                    <div className="file-name">{file.name}</div>
                </div>
            )}
        </StyledFileUploaderBox>
    );
};

export default File;
